import { useRef } from "react";
import logoSvgMarkup from "../../assets/generated/matsushima-auto-logo.svg?raw";
import { useMatsushimaLogoAnimation } from "./useMatsushimaLogoAnimation";

type MatsushimaAutoLogoProps = {
  animate?: boolean;
  intro?: boolean;
  onAnimationComplete?: () => void;
};

export function MatsushimaAutoLogo({
  animate = false,
  intro = false,
  onAnimationComplete,
}: MatsushimaAutoLogoProps) {
  const logoContainerRef = useRef<HTMLSpanElement>(null);

  useMatsushimaLogoAnimation(
    logoContainerRef,
    animate,
    onAnimationComplete,
  );

  return (
    <span
      ref={logoContainerRef}
      className={`matsushima-logo${intro ? " matsushima-logo--intro" : ""}`}
      aria-hidden="true"
      data-testid={intro ? "matsushima-logo-intro" : "matsushima-logo"}
      data-review-region={intro ? "logo-intro" : "header-logo"}
      dangerouslySetInnerHTML={{ __html: logoSvgMarkup }}
    />
  );
}
